import React from "react";

import { CloseOutlined } from "@ant-design/icons";
import { motion } from "framer-motion/dist/framer-motion";
import Highlighter from "react-highlight-words";

import StyledScrollbar from "../../../../Common/UIComponents/StyledScrollbar";

// import "../../../styles/SelectionTileStyle.css";
import "./SelectionCard.css";

export default function SelectionCard({
  data, animationKey, type, updateSelectedOptions, disabled, active, children, searchValue,
}) {
  const selectionTileClicked = () => {
    updateSelectedOptions(data, type);
  };

  let statusClassName = "";
  if (active) {
    statusClassName = "--focused";
  } else if (disabled) {
    statusClassName = "--disabled";
  }

  return (
    <motion.div
      className={`ProductAnalytics__SelectionCard${statusClassName}`}
      onClick={selectionTileClicked}
      key={animationKey}
      layout
      layoutId={animationKey}
    >
      <StyledScrollbar
        autoHide
        className="ProductAnalytics__SelectionCard__Scrollbar"
      >
        <div className="ProductAnalytics__SelectionCard__Content">
          {typeof data === "string" ? (
            <Highlighter
              key={animationKey}
              className="Analytics__SelectionCard__ValueText"
              highlightClassName="Analytics__SelectionCard__ValueText--highlighted"
              searchWords={[searchValue]}
              autoEscape
              textToHighlight={data}
            />
          ) : children }
        </div>
      </StyledScrollbar>
      {active && (
      <CloseOutlined className="ProductAnalytics__SelectionCard__CloseIcon" aria-hidden />
      )}
    </motion.div>
  );
}
